import { formatIranMobile, formatToman, toPersianDigits } from '@clinic/money-date';
import { fa } from '../i18n/fa';

/** Display only: amounts stay rial strings everywhere else (CLAUDE.md §4). */
export function toman(rial: string | bigint): string {
  return `${formatToman(rial)} ${fa.app.toman}`;
}

export function personName(p: { firstName: string; lastName: string | null }): string {
  return p.lastName ? `${p.firstName} ${p.lastName}` : p.firstName;
}

export function phoneLabel(e164: string | null): string {
  return e164 ? formatIranMobile(e164) : fa.app.none;
}

export function fa2(n: number): string {
  return toPersianDigits(String(n));
}
